import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DriverCommissionForm from './DriverCommissionForm';
import { postDriverCommission } from '../../../../actions';
import Content from '../../../layout/Content';
import { DRIVER_COMMISSION_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

const NewDriverCommission = ({ dispatchPostDriverCommission, breadcrumbs }) => {
  const handleSubmit = (formValues) => {
    const { name, description, baseCommission, driverCommissionRangeList } =
      formValues;
    const newFormValues = {
      driverCommissionRangeList: driverCommissionRangeList
        ? driverCommissionRangeList.map(
            ({ commission, startRange, driverType }) => ({
              commission,
              startRange,
              driverTypeId: driverType ? driverType.value : null,
            }),
          )
        : [],
      name,
      description,
      baseCommission,
    };
    dispatchPostDriverCommission(newFormValues);
  };

  const content = <DriverCommissionForm onSubmit={handleSubmit} />;

  return (
    <Content
      title="Nueva Comisión de Conductor"
      subtitle="Crear nueva comisión de conductor"
      content={content}
      breadcrumbs={breadcrumbs}
    />
  );
};

NewDriverCommission.propTypes = {
  dispatchPostDriverCommission: PropTypes.func.isRequired,
  breadcrumbs: breadcrumbsPropTypes.isRequired,
};

const mapStateToProps = (
  { HumanResourcesUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...HumanResourcesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Comisiones de Conductores',
      href: DRIVER_COMMISSION_PATH,
    },
    {
      text: 'Ver',
      href: `${DRIVER_COMMISSION_PATH}/${id}`,
    },
  ],
});

const mapDispatchToProps = {
  dispatchPostDriverCommission: postDriverCommission,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewDriverCommission);
